export const formatTestId = (id: string, prefix = "") => {
  return `${prefix}-${id}`
    .toLocaleLowerCase()
    .replace(/-/g, " ")
    .split(" ")
    .filter((c) => c)
    .join("-");
};
